import type { GivingDetail } from 'models';
import { Alert, CalendarTimeAddFillIcon, Card } from 'ui';

type P = {
  giving: GivingDetail;
};

const FinishedAlertCard = ({ giving }: P) =>
  giving.status === 'finished' ? (
    <Card>
      <Alert description="Giving finished" icon={<CalendarTimeAddFillIcon />} type="neutral" />
    </Card>
  ) : null;

export default FinishedAlertCard;
